<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import vue2Dropzone from "vue2-dropzone";
import BannerApi from "@/services/banner-api";
import AnnouncementsApi from "@/services/announcements-api";
import eventLogApi from "@/services/event-log-api";
import i18n from "../../../i18n";
// import {Priviliges} from "../../../privileges";
import {Dimensions} from "./bannerDimensions";
import {ImageDimensions} from "./announcementDimensions";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import CustomersApi from "@/services/customers-api";
import PartnerApi from "@/services/partner-api";
import AccessHistory from "@/components/accessHistory";

export default {
  page: {
    title: "Bannières",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, vueDropzone: vue2Dropzone, DatePicker,AccessHistory
  },

  data() {
    return {

      bannerListFields: [
            {key:"name",  label:"nom Image" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle", thStyle:"width:100px;"},
            {key:"startDate",  label:"Date Debut" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle", thStyle:"min-width:220px; width:220px"},
            {key:"endDate",  label:"Date Fin" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle", thStyle:"min-width:220px; width:220px"},
            {key:"position",  label:"Position" , thClass:"text-center font-size-16 text-dark", tdClass:"text-center align-middle",thStyle:"width:50px;" },
            {key:"isActive",  label:"Active" , thClass:"text-center font-size-16 text-dark", tdClass:"text-center align-middle", thStyle:"width:50px;"},
            {key:"show",  label:"" , thClass:"text-center font-size-16 text-dark", tdClass:"text-center align-middle", thStyle:"width:50px;"},
            {key:"action",  label:"" , thClass:"text-center font-size-16 text-dark", tdClass:"text-center align-middle", thStyle:"width:50px;"},
           
          ],
      eventLogFelds: [
            {key:"timeStamp",  label:"" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle", thStyle:"width:150px;"},
            {key:"userName",  label:"" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle", thStyle:"width:150px;"},
            {key:"action",  label:"" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle", thStyle:"min-width:220px; width:220px"},
            {key:"params",  label:"" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle", thStyle:"min-width:220px; width:220px"},
            {key:"referer",  label:"" , thClass:"text-center font-size-16 text-dark", tdClass:"text-center align-middle", thStyle:"min-width:220px; width:220px"},
            {key:"paramsReferer",  label:"" , thClass:"text-center font-size-16 text-dark", tdClass:"text-center align-middle",thStyle:"width:220px;" },
            {key:"ipAddress",  label:"" , thClass:"text-center font-size-16 text-dark", tdClass:"text-left align-middle",thStyle:"width:100px;" },
            {key:"userAgent",  label:"" , thClass:"text-center font-size-16 text-dark", tdClass:"text-left align-middle",thStyle:"width:630px;" },
        
      ],

      nearFelds: [
            {key:"near",  label:"" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle",},
            {key:"csvKey",  label:"" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle font-weight-bold",},
            {key:"timeStamp",  label:"" , thClass:"text-left font-size-16 text-dark", tdClass:"text-left align-middle font-weight-bold", },
            {key:"actions",  label:"" , thClass:"text-center font-size-16 text-dark", tdClass:"text-center align-middle", thStyle:"width:150px;"},




        
      ],

      bannerList: [],
      bannerLoginList: [],
      newsTypeList: [{name:i18n.t('parameters.highlight'), value: 0 }, {name:i18n.t('parameters.news'), value: 1},{name:i18n.t('parameters.promotion'), value: 2}],

      selectedAnnouncment:{id:null,title:'',tag:'',type:'',date:'',description:'',titleEn:'' , tagEn:'' , descriptionEn:''},
      pagemodelMain: { currentPage: 1, perPage: 10, totalRows: 0 },
      pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
      isAnnouncmentsTableBusy:false,
      showBannerImageModal: false,
      showAllBanner: false,
      showAnnouncementsModal:false,
      isLinkImage:false,
      imageModalUrl: "",
      bannerModalUrl: "",
      selectedBanner: {
        id: null,
        name: null,
        generatedName: null,
        position: 1,
      },

      selectedBannerLogin: {
        id: null,
        name: null,
        generatedName: null,
        position: 1,
      },

      formData: null,
      selectedImage: null,
      endOfFindBanner: false,
      isBannerTableBusy: false,
      dropzoneOptions: {
              url: "/",
              thumbnailWidth: 150,
              addRemoveLinks: true,
              autoProcessQueue:false,
            },
      formError:false,
      announcementsList:[],
      selectedType:null,
      privileges:"",
      
      isAdmin:true,
      hasAnnouncementsAccess:true,
      hasBannersAccess:true,
      
      uploadingBannerStarting:false,
      uploadingBannerLoginStarting:false,

      dimensions : Dimensions,
      imageDimensions:ImageDimensions,
      activeTab:0,
      saveAnouncementStarting:false,

      blockOrderMessage: null,

      isBannerLoginTableBusy: false,

      bannerLoginStartDate: null,
      bannerLoginEndDate: null,

      uploadingBannerAdsStarting:false,
      selectedBannerAds:null,
      showAllBannerAds:false,
      bannerAdsList:null,
      isBannerAdsTableBusy:false,
      announcement:null,
      startEventLog:null,
      endEventLog:null,
      eventLogList: null,
      isEventLogTableBusy:false,
      eventLogId:null,
      adminEventLog:null,
      
      customersList:[],
      selectedCustomer:null,

      isNearTableBusy:false,
      nearList:false,
      selectedPartnerNear:{
        near:null,
        csvKey:null
      },
      showFormPartnerNear: false,


    };
  },

  mounted() {

    
    if(this.isAdmin || this.hasBannersAccess ){

      this.findAllEventLog(); this.getCustomers();

      this.findBanner();
      this.findBannerAds();

      this.findAllPartnerNear()
    }

  },

  watch:{
    startEventLog: function(){
      this.findAllEventLog()
    },
    endEventLog: function(){
      this.findAllEventLog()
    },

    selectedCustomer:function(){
      this.findAllEventLog()
    },

    adminEventLog:function(){
      this.findAllEventLog()

    }


  },

  methods: {

    openFormPartnerNear(){
      this.selectedPartnerNear = {near: null , csvKey: null }
      if(!this.showFormPartnerNear){
        this.showFormPartnerNear = true
      }
    },

    updatePartnerNear(item){
      this.showFormPartnerNear = true
      this.selectedPartnerNear = item
    },

    deletePartnerNear(item){

      Swal.fire({
        title: i18n.t('parameters.swal.removePartnerNear.title'),
        html: item.near,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d11010",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('parameters.swal.removePartnerNear.cancelButtonText'),
        confirmButtonText: i18n.t('parameters.swal.removePartnerNear.confirmButtonText'),
      }).then((result) => {
        if (result.value) {
          this.isNearTableBusy = true;
          PartnerApi.deletePartnerNear(this.pagemodel.currentPage, this.pagemodel.perPage,item.code)
          .then((result) => {
              if(result){
                  this.nearList=result.list;
                  this.pagemodel.totalRows = result.total;
                  this.pagemodel.currentPage = result.page;
                  this.pagemodel.perPage = result.pageSize;
                  this.pagemodel.pageSize = result.pageSize;
              }
              
            })
            .finally(() => {
              this.isNearTableBusy = false;
            });
        }
      });


      },


    savePartnerNear(){
      this.isNearTableBusy = true;
      PartnerApi.savePartnerNear(this.pagemodel.currentPage, this.pagemodel.perPage, this.selectedPartnerNear)
      .then((result) => {
          if(result){
              this.nearList=result.list;
              this.pagemodel.totalRows = result.total;
              this.pagemodel.currentPage = result.page;
              this.pagemodel.perPage = result.pageSize;
              this.pagemodel.pageSize = result.pageSize;
          }
          
        })
        .finally(() => {
          this.isNearTableBusy = false;
          this.showFormPartnerNear = false

        });

    },


    findAllPartnerNear(){
      this.isNearTableBusy = true;

      PartnerApi.findAllPartnerNear(this.pagemodel.currentPage, this.pagemodel.perPage)
      .then((result) => {
          if(result){
              this.nearList=result.list;
              this.pagemodel.totalRows = result.total;
              this.pagemodel.currentPage = result.page;
              this.pagemodel.perPage = result.pageSize;
              this.pagemodel.pageSize = result.pageSize;
          }
          
        })
        .finally(() => {
          this.isNearTableBusy = false;
        });
    },

    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
          response => {
          this.customersList=response;
          }
      )
      },

    parseParams(value) {
    if ( value && typeof value === 'string') {
      return value
        .replace(/[{}]/g, '')
        .split(', ')
        .reduce((acc, pair) => {
          const [key, val] = pair.split('=');
          acc[key.trim()] = isNaN(val) ? val.trim() : Number(val);
          return acc;
        }, {});
    }
    return value; 
  },

    findAllEventLog(){
      this.isEventLogTableBusy = true;
      eventLogApi.getEventLog(this.pagemodel.currentPage, this.pagemodel.perPage, this.startEventLog, this.endEventLog ,this.selectedCustomer == null ? null : this.selectedCustomer.id , this.adminEventLog)
        .then((result) => {
          if(result){
              this.eventLogList=result.list;
              this.pagemodel.totalRows = result.total;
              this.pagemodel.currentPage = result.page;
              this.pagemodel.perPage = result.pageSize;
              this.pagemodel.pageSize = result.pageSize;
          }
          
        })
        .finally(() => {
          this.isEventLogTableBusy = false;
        });
    },

    findBannerAds(){
      this.isBannerAdsTableBusy = true;
      BannerApi.getBannersAds(this.pagemodel.currentPage, this.pagemodel.perPage,)
        .then((result) => {
          if(result){
              this.bannerAdsList=result.list;
              this.pagemodel.totalRows = result.total;
              this.pagemodel.currentPage = result.page;
              this.pagemodel.perPage = result.pageSize;
              this.pagemodel.pageSize = result.pageSize;
          }
          
        })
        .finally(() => {
          this.isBannerAdsTableBusy = false;
        });
    },

    removeBannerAds(bannerAds){
      Swal.fire({
        title: i18n.t('parameters.swal.removeBanner.title'),
        html: bannerAds.title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d11010",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('parameters.swal.removeBanner.cancelButtonText'),
        confirmButtonText: i18n.t('parameters.swal.removeBanner.confirmButtonText'),
      }).then((result) => {
        if (result.value) {
          BannerApi.removeBannerAds(bannerAds.id).then(() => {
            this.findBannerAds();
          });
        }
      });

    },
    editBannerAds(bannerAds){
      BannerApi.editBannerAds(bannerAds).then((result) => {
        if (result) {
          this.findBannerAds();
        }
      });
    },

    onBannerAdsUpload(){
      this.uploadingBannerAdsStarting=true;
      this.selectedBannerAds = event.target.files[0];
      this.uploadBannerAds();
    },





    findBanner() {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(null)
        .then((result) => {
          if(result){
            this.bannerList = result;
          }
          
        })
        .finally(() => {
          this.isBannerTableBusy = false;
        });
    },

    findBannerLogin() {
      this.isBannerLoginTableBusy = true;
      BannerApi.getBannersLogin(null)
        .then((result) => {
          if(result){
            this.bannerLoginList = result

            if (this.bannerLoginList && this.bannerLoginList.length) {
              this.bannerLoginStartDate = this.bannerLoginList[0].startDate ? new Date( this.bannerLoginList[0].startDate ) : null;
              this.bannerLoginEndDate = this.bannerLoginList[0].endDate ? new Date( this.bannerLoginList[0].endDate ) : null;
            }
            
          }
          
        })
        .finally(() => {
          this.isBannerLoginTableBusy = false;
        });
    },

    uploadBannerAds() {
      const fd = new FormData();
      fd.append("file", this.selectedBannerAds, this.selectedBannerAds.name);
      BannerApi.uploadBannerAds(fd).then((res) => {
        if (res) {
          this.findBannerAds();
          this.uploadingBannerAdsStarting=false;
        }
      }).finally(
        ()=>{
           this.uploadingBannerAdsStarting=false;
        }
      );
    },

    uploadBanner() {
      const fd = new FormData();
      fd.append("file", this.selectedBanner, this.selectedBanner.name);
      BannerApi.uploadBanner(fd).then((res) => {
        if (res) {
          this.findBanner();
          this.uploadingBannerStarting=false;
        }
      }).finally(
        ()=>{
           this.uploadingBannerStarting=false;
        }
      );
    },

    uploadBannerLogin() {
      const fd = new FormData();
      fd.append("file", this.selectedBannerLogin, this.selectedBannerLogin.name);
      BannerApi.uploadBannerLogin(fd).then((res) => {
        if (res) {
          this.findBannerLogin();
          this.uploadingBannerLoginStarting=false;
        }
      }).finally(
        ()=>{
           this.uploadingBannerLoginStarting=false;
        }
      );
    },

    saveLoginBanner() {

      if (!this.bannerLoginList && !this.bannerLoginList.length) {
        return;
      }

      const loginBanner={
          id: this.bannerLoginList[0].id,
          startDate: this.bannerLoginStartDate,
          endDate : this.bannerLoginEndDate,
      }

      BannerApi.saveLoginBanner(loginBanner).then((result) => {
        if (result) {
          this.findBannerLogin();
        }
      });
    },

    onBannerUpload(event) {
      this.uploadingBannerStarting=true;
      this.selectedBanner = event.target.files[0];
      this.uploadBanner();
    },

    onBannerLoginUpload(event) {
      this.uploadingBannerLoginStarting=true;
      this.selectedBannerLogin = event.target.files[0];
      this.uploadBannerLogin();
    },

    removeBanner(banner) {
      Swal.fire({
        title: i18n.t('parameters.swal.removeBanner.title'),
        html: banner.title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d11010",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('parameters.swal.removeBanner.cancelButtonText'),
        confirmButtonText: i18n.t('parameters.swal.removeBanner.confirmButtonText'),
      }).then((result) => {
        if (result.value) {
          BannerApi.removeBanner(banner.id).then(() => {
            this.findBanner();
          });
        }
      });
    },

    savePosition(data) {
      BannerApi.savePosition(data).then((result) => {
        if (result) {
          this.findBanner();
        }
      });
    },

    getType(type){
      if(type==null){
        return;
      }
      switch(type) {
        case 0: return {name:i18n.t('parameters.promotion'), value: 0 };
        case 1: return {name:i18n.t('parameters.news'), value: 1};
        case 2: return {name: i18n.t('parameters.highlight'), value: 2};
        default: return 'supplier';
      }
    },

    editAnnouncement(data){
      this.selectedAnnouncment.id=data.id
      this.selectedAnnouncment.title=data.title
      this.selectedAnnouncment.date=data.date
      this.selectedType=this.getType(data.type)
      this.selectedAnnouncment.tag=data.tag
      this.selectedAnnouncment.description=data.description
      this.selectedAnnouncment.titleEn=data.titleEn
      this.selectedAnnouncment.tagEn=data.tagEn
      this.selectedAnnouncment.descriptionEn=data.descriptionEn
    },

    clearAnnounccement(){
      this.selectedAnnouncment.id=null
      this.selectedAnnouncment.title=""
      this.selectedAnnouncment.date=""
      this.selectedAnnouncment.type=""
      this.selectedAnnouncment.tag=""
      this.selectedAnnouncment.description=""
      this.selectedAnnouncment.titleEn=""
      this.selectedAnnouncment.tagEn=""
      this.selectedAnnouncment.descriptionEn=""
      this.selectedType=null
      this.selectedImage=null
    },

    saveAnnouncment(){

      this.selectedAnnouncment.titleEn = this.selectedAnnouncment.title;
      this.selectedAnnouncment.tagEn = this.selectedAnnouncment.tag;

      this.formError=false
      if(!this.selectedAnnouncment.id){
        this.selectedImage=this.$refs.myVueDropzone.getAcceptedFiles()[0]
      }
      if(!this.selectedAnnouncment.date || !this.selectedAnnouncment.title || !this.selectedAnnouncment.titleEn  || !this.selectedType!=0  || (!this.selectedAnnouncment.id && !this.selectedImage)) {        
        this.formError=true
        return;
      }
      Swal.fire({
        title: this.selectedAnnouncment.id ? i18n.t('parameters.swal.saveAnnouncment.title1') : i18n.t('parameters.swal.saveAnnouncment.title2'),
        html:this.selectedAnnouncment.title,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#d11010",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('parameters.swal.saveAnnouncment.cancelButtonText'),
        confirmButtonText: i18n.t('parameters.swal.saveAnnouncment.confirmButtonText'),
    }).then(result=>{
      if(result.value){
        this.saveAnouncementStarting=true
        if(!this.selectedAnnouncment.id){
          const fd = new FormData();
          fd.set('file',this.selectedImage)
          fd.set('title',this.selectedAnnouncment.title)
          fd.set('titleEn',this.selectedAnnouncment.titleEn)
          fd.set('date',this.selectedAnnouncment.date)
          fd.set('type', !this.selectedType ? null : this.selectedType.value)
          fd.set('tag',this.selectedAnnouncment.tag)
          fd.set('tagEn',this.selectedAnnouncment.tagEn)
          fd.set('description',this.selectedAnnouncment.description)
          fd.set('descriptionEn',this.selectedAnnouncment.descriptionEn)
          AnnouncementsApi.saveAnnouncment(fd).then(
          (result)=>{
            if(result){
              this.getAnnouncments()
              this.selectedAnnouncment={id:null,title:'',tag:'',type:'',date:'',description:'',titleEn:'' , tagEn:'' , descriptionEn:''};
              this.showAnnouncementsModal=false
              this.selectedImage=null
              this.formError=false
              this.selectedType=null
              this.saveAnouncementStarting=false
            }
            this.saveAnouncementStarting=false
          }
          )
        }else{
          this.selectedAnnouncment.type = !this.selectedType ? null : this.selectedType.value
          AnnouncementsApi.editAnnouncement(this.selectedAnnouncment).then(
            (result)=>{
              if(result){
                this.getAnnouncments()
                this.selectedAnnouncment={id:null,title:'',tag:'',type:'',date:'',description:'',titleEn:'' , tagEn:'' , descriptionEn:''};
                this.showAnnouncementsModal=false
                this.selectedImage=null
                this.formError=false
                this.selectedType=null
                this.saveAnouncementStarting=false
              }
              this.saveAnouncementStarting=false
            }
          )
        }
      }}
        )
    },

    getAnnouncments() {
      this.isAnnouncmentsTableBusy = true;
      AnnouncementsApi.getAnnouncments(this.pagemodelMain.currentPage, this.pagemodelMain.perPage)
        .then(result => {
          this.announcementsList = result.list
          this.pagemodelMain.totalRows = result.total;
          this.pagemodelMain.currentPage = result.page;
          this.pagemodelMain.perPage = result.pageSize;
          this.pagemodelMain.pageSize = result.pageSize;
        })
        .finally(() => {
        this.isAnnouncmentsTableBusy = false;
      })
    },

    typeToLabel(type) {
      if (type == null) {
        return '';
      }

      switch(type) {
        case 0: return i18n.t('parameters.promotion');
        case 1: return i18n.t('parameters.news');
        case 2: return i18n.t('parameters.highlight')
        default: return '';
      }
    },

    typeToColor(type) {
      switch(type) {
        case 0: return 'success';
        case 1: return 'danger';
        case 2: return 'light';
        default: return '';
      }
    },

    removeAnnouncement(announcement){
        Swal.fire({
          title: i18n.t('parameters.swal.removeAnnouncement.title'),
          html:announcement.title,
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#d11010",
          cancelButtonColor: "#34c38f",
          cancelButtonText:  i18n.t('parameters.swal.removeAnnouncement.cancelButtonText'),
          confirmButtonText: i18n.t('parameters.swal.removeAnnouncement.confirmButtonText'),
      }).then(
        (result)=>{
          if(result.value){
            AnnouncementsApi.removeAnnouncement(announcement).then(
            (result)=>{
              if(result){
                this.getAnnouncments()
              }
            }
          )
          }
        }
      )
    },

    onAnnouncementImageUpload(event){
      this.selectedImage=event.target.files[0];
      this.uploadAnnouncementImage()
    },

    uploadAnnouncementImage(){
      const fd = new FormData();
      fd.append("file", this.selectedImage, this.selectedImage.name);
      if(!this.selectedAnnouncment || !this.selectedAnnouncment.id){
        return
      }
      AnnouncementsApi.uploadAnnouncementImage(fd,this.selectedAnnouncment.id).then((res) => {
        if (res) {
          this.imageModalUrl = "/api/image/get/" + res;
          this.getAnnouncments();
 
        }
      });

    }
  },
};


</script>

<template>
  <Layout>


    <!-- taille image  -->

    <input
      type="file"
      @change="onBannerAdsUpload"
      ref="bannerAdsInput"
      style="display: none"
    />

    <input
      type="file"
      @change="onBannerUpload"
      ref="imageInput"
      style="display: none"
    />

    <input
      type="file"
      @change="onAnnouncementImageUpload"
      ref="announcementImageInput"
      style="display: none"
    />

    <input
      type="file"
      @change="onBannerLoginUpload"
      ref="bannerLoginInput"
      style="display: none"
    />


    <div class="row pt-0 pr-sm-5 pl-sm-5">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title font-size-25 text-dark text-uppercase pt-2 pb-4" style="font-size:2em;">{{$t('dropDown.Configuration.text')}}</h2>
              <b-tabs  nav-class="nav-tabs-custom" content-class="p-3 text-muted" active-nav-item-class="font-weight-bold text-uppercase ">

                <b-tab v-if="(isAdmin || hasAnnouncementsAccess )&& false" @click="activeTab=1;getAnnouncments()"  >
                  <template v-slot:title>
                      <span>
                        <img  alt="promotion"  width="20px" class="mr-2"  src="@/assets/icons/promotion.svg" style="cursor: pointer;"  />
                      </span>

                      <span class="d-none d-sm-inline-block font-size-16">Promotions</span>
                  </template>
                  <div class="col-sm-12 pr-2">

            
              <!-- button ajouter -->
              <div class="row mb-4 mt-4">
                <div class="col-sm-8"></div>
                <div class="col-sm-4 ">
                    <b-button variant="outline-primary" @click="showAnnouncementsModal=true;formError=false;clearAnnounccement()" class="float-right">
                        <i class="  fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 text-uppercase "></i> 
                        <span class="  text-uppercase font-weight-bold">
                            {{$t('parameters.addNews')}}
                        </span>
                    </b-button>
                </div>
              </div>

              <!-- table -->
              <div class="row ">
                <div class="table-responsive mb-0">
                  <table class="table table-centered table-sm table-striped">
                    <thead class="">
                      <tr>
                        <th class="text-left" style="min-width:150px">{{$t('parameters.title')}}</th>
                        <th class="text-left">{{$t('parameters.date')}}</th>
                        <th class="text-left">{{$t('parameters.image')}}</th>
                        <th class="text-left">{{$t('parameters.type')}}</th>
                        <th class="text-left">{{$t('parameters.tag')}}</th>
                        <th class="text-right"></th>
                        <th class="text-center"></th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(announcement) in this.announcementsList" :key="announcement.id" >
                        <td>
                          {{announcement.title}}
                        </td>
                        <td>
                          <span
                            class="font-size-14 font-weight-bold "
                            >{{announcement.date}}
                          </span>
                        </td>
                        <td class="text-left font-weight-bold font-size-14">
                          <i
                            @click="
                              showBannerImageModal = true;
                              isLinkImage=true;
                              imageModalUrl='/api/image/get/' + announcement.image;
                              selectedAnnouncment=announcement"
                              
                            style="cursor: pointer;text-decoration: underline"
                            class="text-dark font-weight-bold "
                          >{{announcement.imageName}}</i>
                          
                        </td>
                        <td>
                          
                          <h5><b-badge href="#" :variant="typeToColor(announcement.type)">{{typeToLabel(announcement.type)}}</b-badge></h5>
                        </td>
                        <td>{{announcement.tag}}</td>
                        <td class="text-right">
                          <i
                            @click="
                              editAnnouncement(announcement);formError=false;showAnnouncementsModal = true;
                            "
                            :title="$t('parameters.hover.edit')"
                            style="cursor: pointer"
                            class="fas fa-edit text-warning font-size-16"
                          />
                        </td>

                        <td class="text-center ">
                          <a
                            data-v-a99d208c=""
                            :title="$t('parameters.hover.delete')"
                            href="javascript:void(0);"
                            @click="removeAnnouncement(announcement)"
                            class="action-icon text-danger"
                          >
                            <i
                              data-v-a99d208c=""
                              class="mdi mdi-trash-can font-size-22"
                            ></i>
                          </a>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                  <div v-if="isAnnouncmentsTableBusy" class="d-flex justify-content-center">
                    <div class="spinner-border text-success" role="status">
                      <span class=" sr-only">Loading...</span>
                    </div>
                  </div>
                  <span v-if="!isAnnouncmentsTableBusy & !announcementsList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('parameters.tableNewsEmpty')}} </span>
                
                </div>
              </div>
              <!-- Pagination -->
                      <div class="row pt-3 mb-sm-4">
                          <div class="col-sm-8">
                              <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                  <b-form-select @input="getAnnouncments()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{$t('pagination.lines')}}</span></div>
                              </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="dataTables_paginate paging_simple_numbers float-right">
                                  <ul class="pagination pagination-rounded mb-0">
                                  <b-pagination v-model="pagemodelMain.currentPage" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="getAnnouncments()" :disabled="isAnnouncmentsTableBusy" ></b-pagination>
                                  </ul>
                              </div>
                          </div>
                      </div> 
                      <!-- Fin Pagination  -->
                </div>
                </b-tab>

                <b-tab v-if="isAdmin" active @click="activeTab=3;" lazy>
                  
                  <template v-slot:title>
                    <span>
                      <img  alt="map"  width="22px" class="mr-2" fill="#fff" src="@/assets/icons/history-lock.svg" style="cursor: pointer;"/>
                    </span>
                    <span class="d-none d-sm-inline-block font-size-16">{{ $t('accessHistory.tab') }}</span>
                  </template>

                  <AccessHistory />

                </b-tab>

                <b-tab v-if="isAdmin || hasAnnouncementsAccess"  @click="activeTab=2;findAllEventLog(); getCustomers()" lazy>
                  
                  <template v-slot:title>
                    <span>
                      <img  alt="map"  width="20px" class="mr-2" fill="#fff" src="@/assets/icons/event-log.svg" style="cursor: pointer;"/>
                    </span>
                    <span class="d-none d-sm-inline-block font-size-16">{{ $t('eventLog.tab') }}</span>
                  </template>

                  <div class="row align-items-center pb-2 mt-4">
                    <!-- Date Début Input -->
                    <div class="col-12 col-sm-6 col-md-3 p-2">
                      <span class="text-dark font-weight-bold font-size-14">{{ $t('eventLog.startDate') }}</span>
                      <b-form-datepicker
                        v-model="startEventLog"
                        :locale="$t('datPicker.locale')"
                        :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                        dark
                        reset-button
                        close-button
                        :label-reset-button="$t('datPicker.label-reset-button')"
                        :label-close-button="$t('datPicker.label-close-button')"
                        dropright
                        hide-header
                        ></b-form-datepicker> 
                      
                    </div>
                    <!-- Date Fin Input -->
                    <div class="col-12 col-sm-6 col-md-3 p-2">
                      <span class="text-dark font-weight-bold font-size-14">{{ $t('eventLog.endDate') }}</span>
                      <b-form-datepicker
                        v-model="endEventLog"
                        :locale="$t('datPicker.locale')"
                        :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                        dark
                        reset-button
                        close-button
                        :label-reset-button="$t('datPicker.label-reset-button')"
                        :label-close-button="$t('datPicker.label-close-button')"
                        dropright
                        hide-header
                        ></b-form-datepicker> 
                    </div>
                  </div>

                    <div class="col-12 col-sm-6 col-md-3 p-2">
                      <span class="text-dark font-weight-bold font-size-14">{{ $t('lists.customers.filter') }}</span>
                        <b-form-group  label-for="">
                            <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="name" v-model="selectedCustomer">
                            <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                            </v-select>
                        </b-form-group>
                    </div>

                  <div class="col-12 col-sm-6 col-md-3 p-2">
                    <b-form-checkbox
                    value="1"
                    unchecked-value="0"
                    v-model="adminEventLog"
                    class="custom-checkbox custom-checkbox-success mb-0 mt-0"
                    >{{ $t('eventLog.adminEventLog') }}</b-form-checkbox>
                  </div>



                    <div class="table-responsive mt-3"  >
                      <b-table
                        hover 
                      :busy="isEventLogTableBusy"
                      :items="eventLogList"
                      :fields="eventLogFelds" >

                      <template v-slot:head(timeStamp)>
                          {{ $t("eventLog.table.head.timeStamp") }} 
                      </template>
                      <template v-slot:head(referer)>
                          {{ $t("eventLog.table.head.referer") }} 
                      </template>
                      <template v-slot:head(header)>
                          {{ $t("eventLog.table.head.header") }} 
                      </template>
                      <template v-slot:head(params)>
                          {{ $t("eventLog.table.head.params") }} 
                      </template>
                      <template v-slot:head(paramsReferer)>
                          {{ $t("eventLog.table.head.paramsReferer") }} 
                      </template>
                      <template v-slot:head(userName)>
                          {{ $t("reporting.supplier.access.fields.user") }} 
                      </template>
                      <template v-slot:head(ipAddress)>
                          {{ $t("reporting.supplier.access.fields.ip") }} 
                      </template>
                      <template v-slot:head(action)>
                          {{ $t("eventLog.table.head.action") }} 
                      </template>
                      <template v-slot:head(userAgent)>
                          {{ $t("reporting.supplier.access.fields.userAgent") }} 
                      </template>

                      <template v-slot:cell(timeStamp)="{value}">
                          <strong>{{value==null ? "_" : value}}</strong>
                      </template>
                      <template v-slot:cell(userName)="{value}">
                          <strong>{{value==null ? "_" : value}}</strong>
                      </template>
                      <template v-slot:cell(action)="{value}">
                          <div v-if="value==null" >-</div>
                          <b-badge v-else  href="#" variant="success" class="font-size-12">
                                      {{value}}
                        </b-badge>
                      </template>

                      <template v-slot:cell(ipAddress)="{value}">
                          <code>{{value==null ? "_" : value}}</code>
                      </template>

                      <template v-slot:cell(userAgent)="{value}">
                          <code>{{value==null ? "_" : value}}</code>
                      </template>

                      <template v-slot:cell(referer)="{value}">
                        <div v-if="value==null" >-</div>
                        <b-badge v-else  href="#" variant="info" class="font-size-12">
                                      {{value}}
                        </b-badge>
                      </template>

                      <template v-slot:cell(params)="{ value }">
                        <div>
                          <div v-if="value == null ||  Object.keys(value).length === 0">-</div>
                          <div v-else>
                            <span v-for="(item, key) in parseParams(value)" :key="key" class="tag">       
                            <b-badge href="#" variant="light" class="font-size-12">
                              {{ key }}: {{ item }}
                            </b-badge>
                          </span>
                          </div>
                        </div>
                      </template>


                      <template v-slot:cell(paramsReferer)="{value}">
                        <div>
                          <div v-if="value == null ||  Object.keys(value).length === 0">-</div>
                          <div v-else>
                            <span v-for="(item, key) in parseParams(value)" :key="key" class="tag">       
                            <b-badge href="#" variant="light" class="font-size-12">
                              {{ key }}: {{ item }}
                            </b-badge>
                          </span>
                          </div>
                        </div>
                      </template>

                      </b-table>

                      <div v-if="isEventLogTableBusy" class="d-flex justify-content-center">
                        <div class="spinner-border text-success" role="status">
                            <span class=" sr-only">Chargement...</span>
                        </div>
                      </div>
                      <span v-if="!isEventLogTableBusy && ( !eventLogList || !eventLogList.length )" class="d-flex justify-content-center m-4 text-danger" >{{$t('parameters.tableNewsEmpty')}} </span>
                    </div>
                <!-- Pagination -->
                <div class="row pt-3 mb-sm-4">
                    <div class="col-sm-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="findAllEventLog()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findAllEventLog()" :disabled="isEventLogTableBusy" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div> 
                <!-- Fin Pagination  -->

                </b-tab>


  <!-- Partner Near -->

  <b-tab v-if="isAdmin" @click="activeTab=7;findAllPartnerNear()" lazy>
                    
                    <template v-slot:title>
                      <span>
                        <img  alt="near"  width="20px" class="mr-2"  src="@/assets/icons/near.svg" style="cursor: pointer;"  />
                      </span>
                      <span class="d-none d-sm-inline-block font-size-16">{{ $t('near.tab') }}</span>
                    </template>


                    <div class="row mb-4 mt-4">
                      <div class="col-sm-8"></div>
                      <div class="col-sm-4 ">
                          <b-button variant="outline-primary" @click="openFormPartnerNear()" class="float-right">
                              <i class="  fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 text-uppercase "></i> 
                              <span class="  text-uppercase font-weight-bold">
                                  {{$t('near.addNews')}}
                              </span>
                          </b-button>
                      </div>
                    </div>


                    <div v-if="showFormPartnerNear">
                    <div class="d-flex justify-content-center">
                      <div class="row w-100">
                        <div class="col-md-4 col-12 col-xs-12 pr-lg-2">
                          <div class="text-dark font-size-16 pt-2 pb-2">{{$t('near.label.near')}}</div>
                          <b-form-group class="font-weight-bold font-size-14">
                            <b-input-group>
                              <b-form-input :placeholder="$t('near.input.near')" v-model="selectedPartnerNear.near"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </div>

                        <div class="col-md-4 col-12 col-xs-12 pr-lg-2">
                          <div class="text-dark font-size-16 pt-2 pb-2">{{$t('near.label.csvKey')}}</div>
                          <b-form-group class="font-weight-bold font-size-14">
                            <b-input-group>
                              <b-form-input :placeholder="$t('near.input.csvKey')" v-model="selectedPartnerNear.csvKey"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </div>

                        <div class="col-md-4 text-right center-button">
                          <b-button variant="primary" @click="savePartnerNear" class="float-right">
                            <i class="font-size-16 font-weight-bold align-middle text-uppercase"></i>
                            <span class="text-uppercase font-weight-bold">
                              {{$t('buttons.save')}}
                            </span>
                          </b-button>
                          
                        </div>
                      </div>
                    </div>
                  </div>



                      <div class="table-responsive mt-3"  >
                        <b-table
                         hover 
                        :busy="isNearTableBusy"
                        :items="nearList"
                        :fields="nearFelds" >

                          <template v-slot:head(timeStamp)>
                              {{ $t("near.table.head.timeStamp") }} 
                          </template>
                          <template v-slot:head(near)>
                              {{ $t("near.table.head.near") }} 
                          </template>
                          
                          <template v-slot:head(csvKey)>
                              {{ $t("near.table.head.code") }} 
                          </template>

                          <template v-slot:cell(actions)="{item}" >
                            <div style="min-width: 100px;" >
                              <span>
                                <b-button  title="Configurer la campagne"  size="sm"  class="bg-light" variant="outline-secondary" @click="updatePartnerNear(item)" >
                                  <img class="align-middle" alt="Edit" width="20px" src="@/assets/icons/pencil.svg" style="cursor: pointer;"  />
                                </b-button> 
                              </span>
                              <span class="ml-3">
                                <b-button  title="Configurer la campagne"  size="sm"  class="bg-light" variant="outline-secondary" @click="deletePartnerNear(item)" >
                                  <img class="align-middle" alt="Edit" width="20px" src="@/assets/icons/trash.svg" style="cursor: pointer;"  />
                                </b-button> 
                              </span>

                            </div>
                          </template>
            
                          
                          

                        </b-table>

                        <div v-if="isNearTableBusy" class="d-flex justify-content-center">
                          <div class="spinner-border text-success" role="status">
                              <span class=" sr-only">Chargement...</span>
                          </div>
                        </div>
                        <span v-if="!isNearTableBusy && ( !nearList || !nearList.length )" class="d-flex justify-content-center m-4 text-danger" >{{$t('parameters.tableNewsEmpty')}} </span>
                      </div>
                  <!-- Pagination -->
                  <div class="row pt-3 mb-sm-4">
                      <div class="col-sm-8">
                          <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                              <b-form-select @input="findAllPartnerNear()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                              <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="dataTables_paginate paging_simple_numbers float-right">
                              <ul class="pagination pagination-rounded mb-0">
                              <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findAllPartnerNear()" :disabled="isEventLogTableBusy" ></b-pagination>
                              </ul>
                          </div>
                      </div>
                  </div> 
                  <!-- Fin Pagination  -->

                  </b-tab>





                <!--banner -->
                <b-tab v-if="isAdmin || hasBannersAccess"  class="border-0"  lazy @click="activeTab=4">
                  <template v-slot:title>
                      <span>
                        <img  alt="adversal"  width="20px" class="mr-2"  src="@/assets/icons/brand-adversal.svg" style="cursor: pointer;"  />
                      </span>
                      <span class="d-none d-sm-inline-block font-size-16">Bannières Principales </span>
                  </template>
              
                  <div class="row pt-2">
                    <div class="col-sm-12 pr-2">
                      
                      <!-- button ajouter-->
                      <div class="row pb-4 mt-4">             
                        
                        <!-- <div class="col-xl-6 col-lg-6 col-md-6 "></div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <b-button variant="outline-danger" @click="showAllBanner = true">
                                <i class="  fas fa-images font-size-16 font-weight-bold align-middle mr-2 "></i> 
                                <span class="  text-uppercase font-weight-bold">
                                    {{$t('parameters.hover.arrows')}}
                                </span>
                            </b-button>
                        </div> -->
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">

                          <b-button variant="outline-secondary" @click="showAllBanner = true" class="mr-md-2 mr-0">
                                <i class="  fas fa-images font-size-16 font-weight-bold align-middle mr-2 "></i> 
                                <span class="  text-uppercase font-weight-bold">
                                    {{$t('parameters.hover.arrows')}}
                                </span>
                            </b-button>

                            <b-button variant="outline-primary" @click="$refs.imageInput.click()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="uploadingBannerStarting">
                                <b-spinner small :class="uploadingBannerStarting ? '' : 'd-none'"></b-spinner>
                                <i class=" fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 "></i> 
                                <span class=" text-uppercase font-weight-bold">
                                    {{$t('parameters.addBanner')}}
                                </span>
                            </b-button>
                        </div>
                      </div>

                      <!-- table -->
                      <div class="table-responsive mb-0" >
                        <table class="table table-centered " >
                          <thead class="thead-light">
                            <tr>
                              <!-- <th class="text-left">{{$t('parameters.dateAdd')}} </th> -->
                              <th class="text-left">{{$t('parameters.image')}}</th>
                              <th class="text-left" style="width:9.375em">{{$t('parameters.position')}}</th>
                              <th class="text-center" style="width:9.375em">Mobile</th>
                              <th class="text-right"></th>
                              <th class="text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="data in bannerList" :key="data.id">
                              <!-- <td>
                                <span  class="font-size-14 font-weight-bold ">{{data.creationDateStr}} </span>
                              </td> -->
                              <td class="text-left font-weight-bold font-size-14">
                                {{ data.name }}
                              </td>
                              <td class="text-left">
                                  <div class="input-group input-group-sm pull-right mb-0"  >
                                    <b-form-input v-model="data.position" type="number" name="number" size="sm" class="no-shadow p-1" @keyup.native.enter="savePosition(data)"></b-form-input>
                                        <div class="input-group-append"  size="sm" >
                                          <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="savePosition(data)" ><i  class="fas fa-save font-size-14"></i></b-button>
                                        </div>
                                    </div>
                              </td>

                              <td class="text-center">
                                <b-form-checkbox
                                    v-model="data.isMobile"
                                    value="true"
                                    unchecked-value="false"
                                    class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                        @input="savePosition(data)">    
                                </b-form-checkbox>
                              </td>

                              <td class="text-right">
                                <i @click="imageModalUrl= '/api/image/get/' + data.generatedName;showBannerImageModal = true;isLinkImage=false"  style="cursor: pointer;" class="far fa-eye text-info" />
                              </td>
                              <td class="text-center ">
                                <a  href="javascript:void(0);" @click="removeBanner(data)" :class="data.id ? '' : 'd-none'" class="action-icon text-danger ">
                                  <i  class="mdi mdi-trash-can font-size-22 "></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div v-if="isBannerTableBusy" class="d-flex justify-content-center">
                              <div class="spinner-border text-success" role="status">
                                        <span class=" sr-only">Chargement...</span>
                              </div>
                        </div>
                        <span v-if="!isBannerTableBusy && !bannerList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('parameters.tableBannerEmpty')}} </span>
                      </div>
                    </div>
                  </div>
                </b-tab>

                   <!-- banner ADS-->
                <!-- <b-tab v-if="isAdmin || hasBannersAccess" class="border-0"  lazy @click="activeTab=5">
                    <template v-slot:title>
                        <span>
                          <img  alt="adversal"  width="20px" class="mr-2"  src="@/assets/icons/brand-adversal.svg" style="cursor: pointer;"  />
                        </span>
                        <span class="d-none d-sm-inline-block font-size-16">Bannières Publicitaires </span>
                    </template>
                
                    <div class="row pt-2">
                      <div class="col-sm-12 pr-2">
                        
                        <div class="row pb-4 mt-4">             

                          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">

                            <b-button variant="outline-secondary" @click="showAllBannerAds = true" class="mr-md-2 mr-0">
                                  <i class="  fas fa-images font-size-16 font-weight-bold align-middle mr-2 "></i> 
                                  <span class="  text-uppercase font-weight-bold">
                                      {{$t('parameters.hover.arrows')}}
                                  </span>
                              </b-button>

                              <b-button variant="outline-primary" @click="$refs.bannerAdsInput.click()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="uploadingBannerAdsStarting">
                                  <b-spinner small :class="uploadingBannerAdsStarting ? '' : 'd-none'"></b-spinner>
                                  <i class=" fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 "></i> 
                                  <span class=" text-uppercase font-weight-bold">{{$t('parameters.addBanner')}}</span>
                              </b-button>
                          </div>
                        </div>

                        <div class="table-responsive"  >
                <b-table
                hover 
                :busy="isBannerAdsTableBusy"

                :items="bannerAdsList"
                :fields="bannerListFields" >

                    <template v-slot:cell(isActive)="{ item }">
                      <b-form-checkbox
                          v-model="item.isActive"
                          value="true"
                          unchecked-value="false"
                          class="custom-checkbox custom-checkbox-success mb-0 mt-0"
                              @input="editBannerAds(item)">    
                      </b-form-checkbox>
                    </template>

                    <template v-slot:cell(position)="{ item }">
                      <div class="input-group input-group-sm pull-right mb-0"  >
                            <b-form-input v-model="item.position" type="number" name="number" size="sm" class="no-shadow p-1" @keyup.native.enter="editBannerAds(item)"></b-form-input>
                                <div class="input-group-append"  size="sm" >
                                  <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="editBannerAds(item)" ><i  class="fas fa-save font-size-14"></i></b-button>
                                </div>
                            </div>
                        </template>

                        <template v-slot:cell(regionCode)="{ item }">
                            <div class="text-left font-weight-bold font-size-14">
                                {{ item.regionCode ? item.regionCode : "_" }}
                              </div>
                        </template>

                        <template v-slot:cell(name)="{ item }">
                            <div class="text-left font-weight-bold font-size-14">
                                {{ item.name }}
                              </div>
                        </template>

                        <template v-slot:cell(show)="{ item }">
                          <i @click="imageModalUrl= '/api/image/get/' + item.generatedName;showBannerImageModal = true;isLinkImage=false"  style="cursor: pointer;" class="far fa-eye text-info" />
                        </template>

                        <template v-slot:cell(action)="{ item }">
                            <a  href="javascript:void(0);" @click="removeBannerAds(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger ">
                              <i  class="mdi mdi-trash-can font-size-22 "></i>
                            </a>
                        </template>
                        
                        <template v-slot:cell(startDate)="{ item }">
                          <b-form-datepicker
                          v-model="item.startDate"
                          :locale="$t('datPicker.locale')"
                          :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                          dark
                          reset-button
                          close-button
                          :label-reset-button="$t('datPicker.label-reset-button')"
                          :label-close-button="$t('datPicker.label-close-button')"
                          dropright
                          hide-header
                          @input="editBannerAds(item)"
                          ></b-form-datepicker>                        
                        </template>

                        <template v-slot:cell(endDate)="{ item }">
                          <b-form-datepicker
                          v-model="item.endDate"
                          :locale="$t('datPicker.locale')"
                          :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                          dark
                          reset-button
                          close-button
                          :label-reset-button="$t('datPicker.label-reset-button')"
                          :label-close-button="$t('datPicker.label-close-button')"
                          dropright
                          hide-header
                          @input="editBannerAds(item)"
                          ></b-form-datepicker>  
                        </template>
                     
                </b-table>

                  <div v-if="isBannerAdsTableBusy" class="d-flex justify-content-center">
                    <div class="spinner-border text-success" role="status">
                        <span class=" sr-only">Chargement...</span>
                    </div>
                  </div>
                    <span v-if="!isBannerAdsTableBusy && ( !bannerAdsList || !bannerAdsList.length )" class="d-flex justify-content-center m-4 text-danger" >{{$t('parameters.tableBannerEmpty')}} </span>
                  </div>
                  <div class="row pt-3 mb-sm-4">
                          <div class="col-sm-8">
                              <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                  <b-form-select @input="findBannerAds()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
                              </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="dataTables_paginate paging_simple_numbers float-right">
                                  <ul class="pagination pagination-rounded mb-0">
                                  <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findBannerAds()" :disabled="isBannerAdsTableBusy" ></b-pagination>
                                  </ul>
                              </div>
                          </div>
                      </div> 
                      </div>
                    </div>
                </b-tab> -->
                  
                 

                <!-- Login Banner -->
                <b-tab v-if="(isAdmin || hasAnnouncementsAccess) && false" @click="activeTab=6;findBannerLogin()"  >
                  <template v-slot:title>
                      <span>
                        <img  alt="adversal"  width="20px" class="mr-2"  src="@/assets/icons/hands-helping.svg" style="cursor: pointer;"  />
                      </span>
                        <span class="d-none d-sm-inline-block font-size-16">Bannière de Bienvenue</span>
                  </template>

                  
                    <!-- button ajouter-->
                    <div class="row pb-4 mt-4">             
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                            <b-button variant="outline-primary" @click="$refs.bannerLoginInput.click()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="uploadingBannerLoginStarting">
                                <b-spinner small :class="uploadingBannerLoginStarting ? '' : 'd-none'"></b-spinner>
                                <i class=" fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 "></i> 
                                <span class=" text-uppercase font-weight-bold">
                                    Ajouter une bannière de bienvenue
                                </span>
                            </b-button>
                          </div>
                        </div>
                
                        <div class="row pb-5 mt-4" v-for="(banner, index) in bannerLoginList" :key="index">
                          <div class="col-6 p-4" >
                            <!-- <span class="text-primary font-weight-bold font-size-16 text-uppercase ">Bannière</span> -->
                            <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image" width="100%" style="border: 1px solid #ddd; border-radius:7px;">
                          </div>

                          <div class="col-6 p-4">

                            <b-alert v-if="!banner.startDate || !banner.endDate" show variant="danger" class="text-justify mb-4 mt-4">
                                <i class="mdi mdi-alert-outline mr-2"></i> La bannière de bienvenue ne s'affiche que si la date de début et date de fin sont correctement configurées.
                            </b-alert>

                            <div> 
                              <span class="text-dark font-weight-bold font-size-14 ">Date Début</span>
                              <date-picker  v-model="bannerLoginStartDate" format="DD/MM/YYYY HH:mm"
                                  placeholder="Sélectionnez la date et l'heure" type="datetime"></date-picker>
                            </div>
                            
                            <div class="mt-5">    
                              <span class="text-dark font-weight-bold font-size-14 pt-4">Date Fin</span>
                              <date-picker  v-model="bannerLoginEndDate"  format="DD/MM/YYYY HH:mm"
                                  placeholder="Sélectionnez la date et l'heure" type="datetime"></date-picker>

                            </div>

                            <div class="mt-5">
                              <b-button variant="primary" @click="saveLoginBanner" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 font-weight-bold" :disabled="uploadingBannerLoginStarting">
                                  ENREGISTRER LES DATES
                              </b-button>
                            </div>

                          </div>

                        </div>

    
                </b-tab>



                
                 

                
              </b-tabs>

              <b-alert v-if="activeTab != 2 &&  activeTab != 3  && activeTab != 7 " show variant="light" class="text-justify mb-4 mt-4">
                  <i class="mdi mdi-alert-outline mr-2"></i>{{$t('parameters.imageSize')}}
                  <span class="font-weight-bold"> 5Mo </span
                  >. {{$t('parameters.imageType')}}
                  <span class="font-weight-bold"> PNG </span>,
                  <span class="font-weight-bold">JPG </span>,
                  <span class="font-weight-bold"> BMP</span>, {{$t('parameters.and')}}
                  <span class="font-weight-bold">GIF</span>.
                  <!-- <span v-if="activeTab==0">{{$t('parameters.dimensions')}}<span class="font-weight-bold"> {{dimensions[0]["width"]}} X {{dimensions[0]["height"]}} px </span> .</span> -->
                  <!-- <span v-if="activeTab==1">{{$t('parameters.imagesDimensions')}}<span class="font-weight-bold"> {{imageDimensions[0]["width"]}} X {{imageDimensions[0]["height"]}} px </span> .</span> -->
              </b-alert>

          </div>
        </div>
      </div>
    </div>

      
    <!-- </div> -->

    <b-modal
      v-model="showBannerImageModal"
      :title="!isLinkImage ? $t('parameters.modal.modalBannerTitle'):$t('parameters.modal.modalNewsTitle')"
      centered
      :hide-footer="!isLinkImage"
      title-class="text-primary"
      title-tag="h5"
      header-close-variant="danger"
      :size="!isLinkImage? 'xl' : 'l'"
    >
      <div class="row p-2">
        <img v-bind:src="imageModalUrl" alt style="width: 100%; height: 100%" />
      </div>
       <template v-if="isLinkImage" v-slot:modal-footer>
          <b-button  variant="danger" @click="$refs.announcementImageInput.click()" size="md" ><span class=" font-weight-bold">Modifier</span></b-button>
        </template>
      
    </b-modal>
    <b-modal
      v-model="showAllBannerAds"
      :title=" $t('parameters.modal.modalAllBannerTitle')"
      hide-footer
      centered
      title-class="text-primary"
      title-tag="h5"
      header-close-variant="danger"
      size="xl"
    >
      <div style="background-color: #2a323c">
          <b-carousel
                style="text-shadow: 0px 0px 2px #000"
                img-width="1597"
                img-height="279"
                :interval="4000"
                indicators
                controls
              >
                <div v-for="banner in bannerAdsList" :key="banner.id" >
                  <b-carousel-slide v-if="!isBannerAdsTableBusy"
                    :img-src="'/api/banner/get/' + banner.generatedName"
                  ></b-carousel-slide>
                </div>
            </b-carousel>
      </div>
    </b-modal>


    <b-modal
      v-model="showAllBanner"
      :title=" $t('parameters.modal.modalAllBannerTitle')"
      hide-footer
      centered
      title-class="text-primary"
      title-tag="h5"
      header-close-variant="danger"
      size="xl"
    >
      <div style="background-color: #2a323c">
          <b-carousel
                style="text-shadow: 0px 0px 2px #000"
                img-width="1597"
                img-height="279"
                :interval="4000"
                indicators
                controls
              >
                <div v-for="banner in bannerList" :key="banner.id" >
                  <b-carousel-slide v-if="!isBannerTableBusy"
                    :img-src="'/api/banner/get/' + banner.generatedName"
                  ></b-carousel-slide>
                </div>
            </b-carousel>
      </div>
    </b-modal>

    <b-modal 
       v-model="showAnnouncementsModal"  
      :title= "!selectedAnnouncment.id ? $t('parameters.addNews')  : $t('parameters.modal.modalEditNewsTitle')"
      centered  
      title-tag="h5"
      header-close-variant="danger"
      title-class="text-primary"
      size="xl">
      <div >


        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >{{$t('parameters.title')}}<span class="text-danger ml-2" style="font-size: 0.6rem;">({{$t('parameters.mandatory')}})</span></label>
          <div class="col-md-9">
            <input v-model="selectedAnnouncment.title" type="text"  class="form-control" placeholder="Titre de la promotion" />
          </div>
        </div>

        <!-- <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label " ></label>
          <div class="col-md-9">
            <input v-model="selectedAnnouncment.titleEn" type="text"  class="form-control" :placeholder="$t('parameters.titlePlaceHolderEN')"  />
          </div>
        </div> -->

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >{{$t('parameters.date')}}<span class="text-danger ml-2" style="font-size: 0.6rem;">({{$t('parameters.mandatory')}})</span></label>
            <div class="col-md-9">
              <b-form-datepicker
                v-model="selectedAnnouncment.date"
                right
                locale="fr"
                label-no-date-selected="Date"
                dark
              ></b-form-datepicker>
            </div>
        </div>

        <div  class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" for="name">{{$t('parameters.type')}}<span class="text-danger ml-2" style="font-size: 0.6rem;">({{$t('parameters.mandatory')}})</span></label>
          <div class="col-md-9">
            <v-select  class="style-vselect font-size-16" v-model="selectedType" :options="[{name:$t('parameters.promotion'), value: 0 }, /*{name:$t('parameters.news'), value: 1},*/{name:$t('parameters.highlight'), value: 2}]"  :placeholder="$t('parameters.listNews')" label="name">
              <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
            </v-select> 
          </div>
        </div>

        <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >{{$t('parameters.tag')}}</label>
          <div class="col-md-9">
            <input v-model="selectedAnnouncment.tag" type="text"  class="form-control" :placeholder="$t('parameters.tagPlaceHolderFR')"   />
          </div>
        </div> 

        <!-- <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label " ></label>
          <div class="col-md-9">
            <input v-model="selectedAnnouncment.tagEn" type="text"  class="form-control" :placeholder="$t('parameters.tagPlaceHolderEN')"  />
          </div>
        </div>  -->

<!--         <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14"
           >{{$t('parameters.descriptionFR')}}
          </label>
          <div class="col-md-9">
            <ckeditor v-model="selectedAnnouncment.description" :editor="editor" ></ckeditor>
          </div>
       </div> -->

        <!-- <div class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14">
            {{$t('parameters.descriptionEN')}}
          </label>
          <div class="col-md-9">
            <ckeditor v-model="selectedAnnouncment.descriptionEn" :editor="editor" ></ckeditor>
          </div>
       </div> -->


        <div v-if="!selectedAnnouncment.id" class="form-group row mb-3 ml-4">
          <label class="col-md-3 col-form-label font-size-14" >{{$t('parameters.image')}}<span class="text-danger ml-2" style="font-size: 0.6rem;">({{$t('parameters.mandatory')}})</span></label>
          <div class="col-md-9">
            <vue-dropzone
              id="dropzone"
              ref="myVueDropzone"
              maxFileSizeInMB="1"
              maxNumberOfFiles="1"
              :use-custom-slot="true"
              :options="dropzoneOptions"
            >
              <div class="dropzone-custom-content">
                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                <h4>{{$t('parameters.dropImage')}}</h4>
              </div>
            </vue-dropzone>
          </div>
        </div>

        <div  v-if="formError" class="row mb-3 ml-4">
          <div class="col-md-3"/>
          <div class="col-md-9">
            <span  class="text-danger font-size-10 font-italic" >{{$t('parameters.alert')}} </span> 
          </div>
        </div>

      </div>
        <template v-slot:modal-footer>
          <b-button variant="secondary" @click="showAnnouncementsModal = false" size="md">{{$t('buttons.cancel')}}</b-button>
          <b-button  variant="primary" @click="saveAnnouncment()" size="md" :disabled="saveAnouncementStarting" >
            <b-spinner small :class="saveAnouncementStarting ? '' : 'd-none'"></b-spinner>
            <span class="text-white font-weight-bold">{{$t('buttons.save')}}</span>
            </b-button>
        </template>
      </b-modal> 

  </Layout>
</template>

<style scoped>
.center-button{
  align-content: center;
}
</style>

<style scoped>
::v-deep .tabs .nav-item{
  margin-bottom: 10px;
}
</style>